import AddIcon from "@mui/icons-material/Add";
import { Button } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={6}>
		<Button design="default" size="small">Default</Button>
		<Button design="primary" size="small">Primary</Button>
		<Button design="secondary" size="small">Secondary</Button>
		<Button design="outline" size="small">Outline</Button>
		<Button design="link" size="small">Link</Button>
		<Button design="linkSubtle" size="small">Link Subtle</Button>
		<Button
			design="primary"
			size="small"
			startIcon={<AddIcon />}
		/>
		<Button
			design="primary"
			size="small"
			startIcon={<AddIcon />}
		>Primary</Button>
		<Button
			design="secondary"
			size="small"
			startIcon={<AddIcon />}
		>Secondary</Button>
		<Button
			design="outline"
			size="small"
			startIcon={<AddIcon />}
		>Outline</Button>
		<Button
			design="link"
			size="small"
			startIcon={<AddIcon />}
		>Link</Button>
		<Button
			design="linkSubtle"
			size="small"
			startIcon={<AddIcon />}
		>Link Subtle</Button>
		<Button
			design="primary"
			endIcon={<AddIcon />}
			size="small"
		/>
		<Button
			design="primary"
			endIcon={<AddIcon />}
			size="small"
		>Primary</Button>
		<Button
			design="secondary"
			endIcon={<AddIcon />}
			size="small"
		>Secondary</Button>
		<Button
			design="outline"
			endIcon={<AddIcon />}
			size="small"
		>Outline</Button>
		<Button
			design="link"
			endIcon={<AddIcon />}
			size="small"
		>Link</Button>
		<Button
			design="linkSubtle"
			endIcon={<AddIcon />}
			size="small"
		>Link Subtle</Button>
	</CssColumnGrid>
);